<template>
  <div class="red-packet-card" :class="statusClass">
    <div class="left">
      <img :src="require('@/assets/image/hongbao.png')" class="el-icon-present icon hongbao-img" alt="红包">
    </div>
    <div class="center">
      <div class="title">红包</div>
      <div class="greeting">{{ brief.greeting || '恭喜发财，大吉大利' }}</div>
      <div class="meta">
        <span>总额：{{ yuan(brief.totalAmount) }} 元</span>
        <span>份数：{{ brief.totalCount }} 份</span>
        <span v-if="brief.remainCount>0">剩余：{{ brief.remainCount }} 份</span>
      </div>
    </div>
    <div class="right">
      <el-button v-if="canOpen" type="danger" size="mini" @click="onOpen">
        领取红包
      </el-button>
      <span v-else class="status-text">{{ statusText }}</span>
    </div>
  </div>
</template>

<script>
import localforage from 'localforage'
export default {
  name: 'ChatRedPacketBrief',
  props: {
    msgInfo: {
      type: Object,
      required: true
    }
  },
  mounted() {
    if (this.brief && this.brief.id) {
      this.initRefresh();
    }
  },
  data() {
    const brief = this.parseBrief(this.msgInfo.content);
    return {
      brief,
      opening: false,
      claimedByMe: false,
      timer: null,
      refreshIntervalMs: 3000
    };
  },
  methods: {
    parseBrief(content) {
      try { return JSON.parse(content || '{}'); } catch(e) { return {}; }
    },
    yuan(cents) {
      if (!cents && cents !== 0) return '-';
      return (cents / 100).toFixed(2);
    },
    cacheKey() {
      return `red-envelope-${this.brief.id}`;
    },
    async loadCache() {
      try {
        const vo = await localforage.getItem(this.cacheKey());
        if (vo && typeof vo.status === 'number') {
          const uid = this.userStore.userInfo.id;
          this.claimedByMe = (vo.claimedByMe === true) || (Array.isArray(vo.claims) && vo.claims.some(c => c.userId === uid));
          this.brief.status = vo.status;
          if (typeof vo.remainCount === 'number') this.brief.remainCount = vo.remainCount;
          if (typeof vo.remainAmount === 'number') this.brief.remainAmount = vo.remainAmount;
          return vo;
        }
      } catch(e) { let _ = e; }
      return null;
    },
    async saveCache(vo) {
      try { await localforage.setItem(this.cacheKey(), vo); } catch(e) { let _ = e; }
    },
    async fetchDetail() {
      try {
        const vo = await this.$http({ url: '/redEnvelope/detail', method: 'GET', params: { id: this.brief.id } });
        const uid = this.userStore.userInfo.id;
        this.claimedByMe = Array.isArray(vo.claims) && vo.claims.some(c => c.userId === uid);
        if (typeof vo.status === 'number') this.brief.status = vo.status;
        if (typeof vo.remainCount === 'number') this.brief.remainCount = vo.remainCount;
        if (typeof vo.remainAmount === 'number') this.brief.remainAmount = vo.remainAmount;
        await this.saveCache({ ...vo, claimedByMe: this.claimedByMe });
        return vo;
      } catch(e) { return null; }
    },
    async initRefresh() {
      const vo = await this.loadCache();
      if (!vo) {
        const fetched = await this.fetchDetail();
        if (fetched && fetched.status !== 1) return;
      } else {
        if (vo.status !== 1 || vo.remainCount <= 0 || vo.remainAmount <= 0) return;
      }
      this.startRefresh();
    },
    startRefresh() {
      if (this.timer) return;
      this.timer = setInterval(async () => {
        const vo = await this.fetchDetail();
        if (!vo) return;
        if (vo.status !== 1 || vo.remainCount <= 0 || vo.remainAmount <= 0) {
          this.stopRefresh();
        }
      }, this.refreshIntervalMs);
    },
    stopRefresh() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    async onOpen() {
      if (this.opening) return;
      this.opening = true;
      try {
        const isSender = this.msgInfo && this.userStore && this.userStore.userInfo && this.msgInfo.sendId === this.userStore.userInfo.id;
        const isPrivate = !!this.msgInfo && !!this.msgInfo.recvId && !this.msgInfo.groupId;
        if (isPrivate && isSender) {
          this.$message.error('发送者不可领取单聊红包');
          return;
        }
        const amount = await this.$http({ url: `/redEnvelope/open`, method: 'POST', params: { id: this.brief.id } });
        this.$message.success(`领取成功：${(amount/100).toFixed(2)} 元`);
        this.claimedByMe = true;
        if (this.brief.remainCount > 0) {
          this.brief.remainCount = Math.max(0, this.brief.remainCount - 1);
        }
        if (this.brief.remainAmount > 0) {
          this.brief.remainAmount = Math.max(0, this.brief.remainAmount - amount);
        }
        if (this.brief.remainCount === 0 || this.brief.remainAmount === 0) {
          this.brief.status = 2;
        }
        await this.saveCache({
          id: this.brief.id,
          greeting: this.brief.greeting,
          totalAmount: this.brief.totalAmount,
          totalCount: this.brief.totalCount,
          remainAmount: this.brief.remainAmount,
          remainCount: this.brief.remainCount,
          status: this.brief.status,
          claimedByMe: true,
          claims: [{ userId: this.userStore.userInfo.id }]
        });
        if (this.brief.status !== 1 || this.brief.remainCount <= 0 || this.brief.remainAmount <= 0) {
          this.stopRefresh();
        }
      } catch (e) {
        let _ = e;
      } finally {
        this.opening = false;
      }
    }
  },
  computed: {
    canOpen() {
      const isSender = this.msgInfo && this.userStore && this.userStore.userInfo && this.msgInfo.sendId === this.userStore.userInfo.id;
      const isPrivate = !!this.msgInfo && !!this.msgInfo.recvId && !this.msgInfo.groupId;
      return this.brief && this.brief.status === 1 && this.brief.remainCount > 0 && this.brief.remainAmount > 0 && !this.claimedByMe && !(isPrivate && isSender);
    },
    statusText() {
      if (!this.brief) return '';
      if (this.claimedByMe) return '已领取';
      if (this.brief.status === 2) return '已领完';
      if (this.brief.status === 3) return '已过期';
      return '不可领取';
    },
    statusClass() {
      if (this.brief.status === 2) return 'finished';
      if (this.brief.status === 3) return 'expired';
      return 'available';
    }
  }
  ,beforeDestroy() {
    this.stopRefresh();
  }
}
</script>

<style lang="scss" scoped>
.red-packet-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff5f5;
  border: 1px solid #ffd6d6;
  border-radius: 10px;
  padding: 10px 12px;
  min-width: 260px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);

  &.finished { opacity: 0.8; }
  &.expired { opacity: 0.8; filter: grayscale(0.3); }

  .left .icon { font-size: 28px; color: #d42e07; }
  .center { flex: 1; text-align: left; }
  .center .title { font-weight: 600; color: #d42e07; }
  .center .greeting { font-size: 13px; color: #666; }
  .center .meta { font-size: 12px; color: #999; display: flex; gap: 10px; }
  .right { display: flex; align-items: center; }
  .status-text { font-size: 12px; color: #999; }
}
.hongbao-img {
  width: 28px;
  height: 28px;
}
</style>
